import React, { FC, FormEvent, ReactElement, useContext } from 'react'
import { FormProvider, useForm, UseFormMethods } from '../../../../Vendor/react-hook-form/dist/index.ie11'
import CLanguageHandler from '../../../../NonReact/Languages/LanguageHandler'
import { LanguageContext } from '../../../Common/Contexts'
import { ManageCustomRoles } from '../../../../../i18n'
import { ON_CHANGE } from '../../../Common/Constants/HookFormEventNames'
import { DESCRIPTION_COMPONENT_NAME, ROLE_NAME_COMPONENT_NAME } from '../Constants/FieldNames'
import { FooterActions } from '../Actions/FooterActions'
import { EMPTY_STRING } from '../../../../NonReact/constants/Common'
import FormRow from '../../../Common/Components/FormRow/FormRow'
import { RichTextEditor } from '../../../RichTextEditor/RichTextEditor'
import { OutlinedTextInput } from '../../../../ReactRouting/Components/Atoms/Inputs/OutlinedTextInput'

type Props = {
    handleOnSubmit: (data: CustomRolesForm) => void
    closeModal: () => void
}

export type CustomRolesForm = {
    roleName: string
    description: string
}

export const ManageCustomRole: FC<Props> = ({ handleOnSubmit, closeModal }: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler
    language.loadBundle(ManageCustomRoles.NAME)

    // Form context.
    const methods: UseFormMethods<CustomRolesForm> = useForm({
        defaultValues: { roleName: EMPTY_STRING, description: EMPTY_STRING },
        mode: ON_CHANGE
    })
    const { handleSubmit }: UseFormMethods<CustomRolesForm> = methods

    const onSubmit = (data: CustomRolesForm): void => {
        handleOnSubmit(data)
    }

    return (
        <div className='manage-custom-role'>
            <div className='modal-title-report-config'>{language.get(ManageCustomRoles.ManageCustomRoles_Title)}</div>

            <FormProvider {...methods}>
                <form
                    className='form'
                    onSubmit={(event: FormEvent): void => {
                        event.preventDefault()
                        event.stopPropagation()

                        handleSubmit(onSubmit)(event)
                    }}
                >
                    <FormRow>
                        <OutlinedTextInput
                            inputName={ROLE_NAME_COMPONENT_NAME}
                            labelLeft={language.get(ManageCustomRoles.ManageCustomRoles_Role_Name)}
                        />
                    </FormRow>

                    <FormRow>
                        <RichTextEditor
                            name={DESCRIPTION_COMPONENT_NAME}
                            label={language.get(ManageCustomRoles.ManageCustomRoles_Description)}
                        />
                    </FormRow>

                    <FooterActions closeModal={closeModal} />
                </form>
            </FormProvider>
        </div>
    )
}
